import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import styles from "./StatusMessage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var StatusMessage = function StatusMessage(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$typog = _ref.typog,
    typog = _ref$typog === void 0 ? 'caption' : _ref$typog;
  return /*#__PURE__*/_jsx(Text, {
    className: classnames(styles.statusMessageText, className),
    typog: typog,
    role: "alert",
    children: children
  });
};